import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsOrderLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsOrderSuspense'));

export const SettingsOrderAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsOrderLazy />
    </DelayedSuspense>
);
